import { StatusResponseDto } from './StatusResponseDto';
import { ApplicationDto } from './ApplicationDto';
import { ApplicationGGDto } from './ApplicationGGDto';

export class ValidateApplicationDataDto {
  applicationDto: ApplicationDto | ApplicationGGDto;
  validData: boolean;
  statusResponseDto: StatusResponseDto;
}
